var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10,
      strokeDasharray: "6,2"
    },
    d: "M323.834,197.069 c0,10.38-1.28,20.46-3.69,30.1c-0.25,1.02-0.52,2.04-0.81,3.05c-0.27,0.99-0.55,1.97-0.85,2.95 c-3.07,10.06-7.38,19.58-12.76,28.38c-0.54,0.87-1.08,1.74-1.64,2.59c-0.54,0.85-1.1,1.69-1.67,2.52 c-13.14,19.3-31.6,34.68-53.28,44.05c-2.66,1.15-5.37,2.21-8.13,3.18c-12.81,4.49-26.59,6.93-40.93,6.93 c-31.17,0-59.64-11.52-81.4-30.55c-5.92-5.17-11.35-10.9-16.19-17.1c-13.33-17.07-22.28-37.74-25.16-60.3 c-0.04-0.34-0.08-0.67-0.12-1c-0.01-0.05-0.02-0.1-0.01-0.14c-0.58-4.81-0.87-9.7-0.87-14.66c0-3.72,0.16-7.41,0.49-11.05 c0.25-2.92,0.61-5.81,1.08-8.66c0.07-0.47,0.14-0.94,0.23-1.41c7.71-44.87,39.58-81.47,81.74-95.95 c1.89-0.65,3.81-1.26,5.74-1.82c2.89-0.83,5.82-1.57,8.79-2.19c2.77-0.59,5.58-1.08,8.41-1.48c0.05,0,0.09-0.01,0.13-0.01 c3.32-0.46,6.67-0.79,10.06-0.98c0.12-0.01,0.24-0.01,0.36-0.02c2.23-0.12,4.47-0.18,6.72-0.18c0.54,0,1.08,0,1.62,0.01 c0.51,0.01,1.02,0.02,1.52,0.03c9.78,0.24,19.27,1.62,28.36,4.01c2.14,0.56,4.26,1.17,6.36,1.85 C287.764,95.209,323.834,141.929,323.834,197.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M57.109,183.118l0.352,1.964 c0.238,1.331,1.28,2.373,2.612,2.612l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352 c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964 c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352 c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964C56.676,182.85,57.061,182.85,57.109,183.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M310.349,104.699l0.352,1.964 c0.238,1.331,1.28,2.373,2.612,2.612l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352 c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964 c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352 c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964C309.916,104.431,310.301,104.431,310.349,104.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M221.763,337.024l0.352,1.964 c0.238,1.331,1.28,2.373,2.612,2.612l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352 c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964 c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352 c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964C221.331,336.756,221.715,336.756,221.763,337.024z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 75.481,
    cy: 118.877,
    r: 1.952
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 339.234,
    cy: 185.868,
    r: 1.952
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 162.882,
    cy: 340.24,
    r: 1.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.615,241.912c-2.601-3.899-7.037-6.469-12.076-6.469c-3.495,0-6.7,1.237-9.205,3.295 c-2.505-2.058-5.71-3.295-9.205-3.295c-5.919,0-11.002,3.549-13.259,8.632c-7.711,0.341-13.863,6.682-13.863,14.478 c0,8.014,6.497,14.511,14.51,14.511c2.492,0,4.836-0.63,6.884-1.736c2.649,3.507,6.84,5.785,11.574,5.785 c6.04,0,11.215-3.692,13.399-8.941c2.281,1.494,5.004,2.37,7.934,2.37c8.014,0,14.511-6.497,14.511-14.511 C351.82,249.155,347.034,243.41,340.615,241.912z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.996,
    y: 284.045,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.504,
    height: 6.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.098,
    y: 288.141,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.653,
    y: 282.03,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.951,
    y: 284.351,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.661,
    y: 288.141,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.216,
    y: 282.03,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    d: "M328.728,265.342c0.195,0.044,0.349,0.196,0.428,0.379 c0.042,0.044,0.081,0.095,0.114,0.158c0.472,0.921,1.595,1.226,2.491,1.581c1.236,0.49,2.437,1.047,3.757,1.276 c1.382,0.24,2.846,0.281,4.227,0.012c1.38-0.268,2.623-0.915,3.917-1.435c0.084-0.034,0.162-0.046,0.235-0.047 c1.548-1.192,2.811-2.77,3.84-4.413c0.295-0.47,0.571-0.953,0.824-1.447c0.235-0.46,0.53-0.965,0.608-1.484 c0.073-0.491-0.032-0.964,0.109-1.455c0.071-0.246,0.174-0.479,0.292-0.706c-1.917-3.657-5.748-6.153-10.163-6.153 c-1.935,0-3.756,0.481-5.355,1.327c-2.08-2.917-5.488-4.821-9.343-4.821c-0.573,0-1.136,0.043-1.686,0.124 c-1.851-0.795-3.889-1.236-6.03-1.236c-5.432,0-10.199,2.833-12.914,7.099c-1.19-0.539-2.508-0.846-3.899-0.846 c-5.234,0-9.477,4.243-9.477,9.477c0,3.531,1.935,6.606,4.8,8.236c0.342,0.005,0.685,0.018,1.026,0.04 c0.309-0.029,0.616-0.064,0.916-0.088c0.801-0.065,1.575-0.14,2.359-0.329c0.789-0.19,1.549-0.462,2.316-0.724 c0.637-0.217,1.267-0.403,1.761-0.883c0.772-0.749,1.845-0.067,1.925,0.747c0.202,0.147,0.369,0.348,0.45,0.591 c0.159,0.476,0.547,0.795,0.921,1.11c0.455,0.384,0.91,0.772,1.393,1.121c0.96,0.692,1.999,1.29,3.125,1.666 c2.028,0.677,4.188,0.828,6.311,0.702c0.509-0.294,1.117-0.372,1.7-0.49c0.927-0.188,1.739-0.711,2.504-1.246 c1.596-1.116,3.076-2.393,4.267-3.944c0.023-0.03,0.05-0.057,0.075-0.085c0.59-1.08,0.987-2.136,1.359-3.352 C328.019,265.45,328.368,265.26,328.728,265.342z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M328.539,237.512L328.539,237.512 c-3.631,0-6.913,1.57-9.203,4.064c-2.289-2.494-5.571-4.064-9.203-4.064h0c-5.424,0-10.068,3.502-11.788,8.356 c-0.236-0.013-0.474-0.022-0.714-0.022h0c-6.876,0-12.502,5.626-12.502,12.502v0c0,0.762,0.069,1.509,0.201,2.234"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M286.888,264.72c2.186,3.663,6.191,6.13,10.744,6.13h0 c2.76,0,5.318-0.908,7.392-2.438c2.115,3.923,6.266,6.606,11.013,6.606h0c6.03,0,11.097-4.327,12.253-10.029 c2.274,2.327,5.44,3.778,8.93,3.778h0c6.876,0,12.502-5.626,12.502-12.502v0c0-6.108-4.44-11.226-10.252-12.293 c-1.759-3.16-4.848-5.491-8.496-6.219"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 302.445,
    y1: 284.349,
    x2: 302.445,
    y2: 269.875
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 319.155,
    y1: 288.139,
    x2: 319.155,
    y2: 274.622
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 335.708,
    y1: 282.031,
    x2: 335.708,
    y2: 268.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.388,
    y: 284.351,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.098,
    y: 288.141,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.653,
    y: 282.03,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5724 -0.82 0.82 0.5724 -180.0873 172.3133)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 75.175,
    cy: 258.829,
    rx: 26.99,
    ry: 26.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5725 -0.8199 0.8199 0.5725 -180.751 203.4827)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 104.741,
    cy: 275.061,
    rx: 21.515,
    ry: 21.516
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5697 -0.8218 0.8218 0.5697 -180.6915 204.356)",
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    cx: 104.821,
    cy: 274.745,
    rx: 7.955,
    ry: 7.956
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    d: "M88.437,269.579c-0.472-0.288-0.879-0.634-1.184-1.101 c-0.211-0.322-0.347-0.748-0.356-1.135c-0.011-0.441,0.116-0.744,0.279-1.144c0.221-0.543,0.553-1.061,0.873-1.551 c0.295-0.452,0.63-0.924,1.124-1.179c0.344-0.177,0.692-0.294,1.085-0.282c0.458,0.014,0.711,0.102,1.132,0.285 c0.104,0.045,0.204,0.101,0.305,0.154c1.038-3.347,0.986-6.859-0.014-10.081c2.127-1.315,6.659-4.238,6.659-4.238 l0.461-0.84l-1.071-1.988l-7.166,4.334c-0.87-1.698-2.028-3.258-3.454-4.603l2.861-5.921l0.638-1.377l0.022-0.899 l-1.88-1.032l-4.174,7.265c-0.317-0.202-0.633-0.405-0.967-0.588c-1.509-0.828-3.089-1.399-4.691-1.736l0.159-5.682 l-0.329-2.236l-2.28-0.805l-0.008,8.404c-2.08-0.127-4.153,0.123-6.119,0.736l-4.237-6.624l-0.942-0.517l-1.631,0.933 l4.262,7.229c-1.877,0.936-3.594,2.22-5.041,3.825l-7.318-3.783l-0.85,0.414l-0.834,1.52l7.659,3.565 c-0.332,0.48-0.65,0.973-0.937,1.495c-0.882,1.607-1.47,3.295-1.796,5.004l-7.406-0.239l-1.402,0.692l0.157,2.25 l8.369-0.117c-0.068,1.939,0.192,3.864,0.766,5.698l-6.738,4.34l-0.207,1.155l0.973,1.696l6.904-4.843 c0.949,1.96,2.277,3.745,3.951,5.244l-3.935,7.167l0.348,0.884l1.72,0.944l4.036-7.351c0.328,0.21,0.651,0.425,0.998,0.615 c1.522,0.836,3.117,1.399,4.733,1.736l0.068,7.743l0.562,0.794l2.142,0.179l-0.559-8.397 C79.522,275.979,84.881,273.805,88.437,269.579z M82.386,266.489c-2.926,2.916-7.343,4.212-12.035,1.636 c-3.18-1.746-4.785-4.337-5.222-7.078c-0.473-1.742-0.514-3.495-0.103-5.26c0.342-0.886,0.684-1.772,1.026-2.657 c0.928-1.677,2.211-3.011,3.85-4.001c0.83-0.362,1.66-0.723,2.49-1.085c1.052-0.349,2.109-0.474,3.172-0.391 c1.669-0.035,3.449,0.373,5.271,1.373c3.959,2.173,5.483,5.653,5.335,9.106c0.028,0.921-0.062,1.845-0.278,2.773 l-1.026,2.657C84.268,264.759,83.434,265.727,82.386,266.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M94.253,254.235c-0.163-0.703-0.365-1.396-0.604-2.076 l4.383-2.658c0.618-0.374,0.815-1.179,0.44-1.796l-2.744-4.525c-0.375-0.618-1.179-0.815-1.797-0.44l-4.38,2.656 c-0.489-0.524-1.008-1.026-1.561-1.499l2.464-4.489c0.348-0.633,0.116-1.428-0.517-1.776l-4.639-2.547 c-0.633-0.348-1.428-0.116-1.776,0.517l-2.464,4.489c-0.696-0.213-1.398-0.381-2.103-0.513l-0.11-5.122 c-0.016-0.722-0.614-1.295-1.336-1.28l-5.291,0.114c-0.722,0.015-1.295,0.614-1.279,1.336l0.11,5.125 c-0.703,0.163-1.396,0.365-2.076,0.604l-2.658-4.383c-0.375-0.618-1.179-0.815-1.796-0.44l-4.525,2.744 c-0.618,0.375-0.815,1.179-0.44,1.797l2.657,4.38c-0.524,0.489-1.026,1.008-1.499,1.561l-4.489-2.464 c-0.633-0.348-1.428-0.116-1.776,0.517l-2.547,4.639c-0.348,0.633-0.116,1.428,0.517,1.776l4.489,2.464 c-0.213,0.696-0.381,1.398-0.513,2.102l-5.122,0.11c-0.722,0.016-1.295,0.614-1.279,1.336l0.114,5.291 c0.016,0.722,0.614,1.295,1.336,1.279l5.125-0.11c0.163,0.703,0.365,1.395,0.604,2.076l-4.383,2.658 c-0.618,0.375-0.815,1.179-0.44,1.797l2.744,4.525c0.375,0.618,1.179,0.815,1.797,0.44l4.38-2.656 c0.489,0.524,1.008,1.026,1.561,1.499l-2.464,4.489c-0.348,0.633-0.116,1.428,0.517,1.776l4.639,2.547 c0.633,0.348,1.428,0.116,1.776-0.517l2.464-4.489c0.696,0.213,1.398,0.381,2.103,0.513l0.11,5.122 c0.016,0.722,0.614,1.295,1.336,1.28l5.291-0.114c0.722-0.016,1.295-0.614,1.279-1.336l-0.11-5.125 c0.703-0.163,1.395-0.364,2.076-0.604 M70.257,267.98c-5.183-2.846-7.079-9.354-4.233-14.538 c2.846-5.183,9.354-7.078,14.538-4.233s7.079,9.355,4.233,14.538S75.44,270.826,70.257,267.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M122.58,281.022l-3.452-1.895 c0.164-0.535,0.293-1.075,0.394-1.617l3.939-0.085c0.556-0.012,0.996-0.472,0.984-1.027l-0.088-4.07 c-0.012-0.555-0.472-0.996-1.027-0.984l-3.942,0.085c-0.125-0.541-0.28-1.073-0.465-1.597l3.371-2.044 c0.475-0.288,0.627-0.907,0.338-1.382l-2.111-3.481c-0.288-0.475-0.907-0.627-1.382-0.339l-3.369,2.043 c-0.376-0.403-0.775-0.789-1.201-1.153l1.895-3.452c0.267-0.487,0.089-1.099-0.398-1.366l-3.568-1.959 c-0.487-0.267-1.099-0.089-1.366,0.398l-1.895,3.452c-0.535-0.164-1.075-0.293-1.617-0.394l-0.085-3.939 c-0.012-0.555-0.472-0.996-1.027-0.984l-4.07,0.088c-0.555,0.012-0.996,0.472-0.984,1.027l0.085,3.942 c-0.54,0.125-1.073,0.28-1.597,0.465l-2.044-3.371c-0.288-0.475-0.907-0.627-1.382-0.339l-3.481,2.111 c-0.475,0.288-0.627,0.907-0.339,1.382l2.043,3.369c-0.403,0.376-0.789,0.775-1.153,1.201l-3.452-1.895 c-0.487-0.267-1.099-0.089-1.366,0.398l-1.959,3.568c-0.267,0.487-0.089,1.099,0.398,1.366l3.452,1.895 c-0.164,0.535-0.293,1.075-0.394,1.617l-3.939,0.085c-0.555,0.012-0.996,0.472-0.984,1.027l0.088,4.07 c0.012,0.555,0.472,0.996,1.027,0.984l3.942-0.085c0.125,0.54,0.28,1.073,0.465,1.596l-3.371,2.044 c-0.475,0.288-0.627,0.907-0.339,1.382l2.111,3.481c0.288,0.475,0.907,0.627,1.382,0.339l3.369-2.043 c0.376,0.403,0.775,0.789,1.201,1.153l-1.895,3.452c-0.267,0.487-0.089,1.098,0.398,1.366l3.568,1.959 c0.487,0.267,1.099,0.089,1.366-0.398l1.895-3.452c0.535,0.164,1.075,0.293,1.617,0.394l0.085,3.939 c0.012,0.555,0.472,0.996,1.027,0.984l4.07-0.088c0.556-0.012,0.996-0.472,0.984-1.027l-0.085-3.942 c0.54-0.125,1.073-0.28,1.597-0.465l2.044,3.371c0.288,0.475,0.907,0.627,1.382,0.339l3.481-2.111 c0.475-0.288,0.627-0.907,0.339-1.382l-2.043-3.369c0.403-0.376,0.789-0.775,1.153-1.201l3.452,1.895 c0.487,0.267,1.099,0.089,1.366-0.398l1.959-3.568C123.245,281.901,123.067,281.289,122.58,281.022z M100.931,282.001 c-3.987-2.189-5.445-7.195-3.256-11.182c2.189-3.987,7.195-5.444,11.182-3.256s5.445,7.195,3.256,11.182 C109.924,282.732,104.918,284.189,100.931,282.001z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.897,79.906h-62.552c-3.652,0-6.613-2.961-6.613-6.613V59.052 c0-3.652,2.961-6.613,6.613-6.613h62.552c3.652,0,6.613,2.961,6.613,6.613v14.241 C233.51,76.945,230.55,79.906,226.897,79.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.567,100.244h-50.052c-1.59,0-2.879-1.289-2.879-2.879V75.656 c0-1.59,1.289-2.879,2.879-2.879h50.052c1.59,0,2.879,1.289,2.879,2.879v21.708 C223.446,98.955,222.157,100.244,220.567,100.244z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 193.25,
    y1: 74.818,
    x2: 179.385,
    y2: 74.818
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 211.857,
    y1: 74.818,
    x2: 197.992,
    y2: 74.818
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M174.643,74.818h-6.427 c-2.165,0-3.921-1.755-3.921-3.921V59.969c0-2.165,1.755-3.921,3.921-3.921h54.714c2.165,0,3.921,1.755,3.921,3.921 v10.927c0,2.165-1.755,3.921-3.921,3.921h-6.331"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    points: "174.643,74.818 176.965,78.013  179.385,74.818  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    points: "211.857,74.818 214.178,78.013  216.599,74.818  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    points: "193.25,74.818 195.571,78.013 197.992,74.818  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M178.669,85.169c0.675,0.229,1.284,0.609,1.775,1.1 c0.827,0.827,1.34,1.971,1.34,3.233v7.052h-9.141v-7.052c0-1.978,1.258-3.661,3.015-4.296"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 177.133,
    cy: 82.474,
    r: 3.103
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M197.077,85.169c0.675,0.229,1.284,0.609,1.775,1.1 c0.827,0.827,1.34,1.971,1.34,3.233v7.052h-9.141v-7.052c0-1.978,1.258-3.661,3.015-4.296"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 195.541,
    cy: 82.474,
    r: 3.103
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M215.684,85.169c0.675,0.229,1.284,0.609,1.775,1.1 c0.827,0.827,1.34,1.971,1.34,3.233v7.052h-9.141v-7.052c0-1.978,1.258-3.661,3.015-4.296"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 214.147,
    cy: 82.474,
    r: 3.103
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M182.825,61.804h-9.716 c-0.495,0-0.896-0.401-0.896-0.896v-0.323c0-0.495,0.401-0.896,0.896-0.896h9.716c0.495,0,0.896,0.401,0.896,0.896v0.323 C183.721,61.402,183.32,61.804,182.825,61.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M182.937,65.433h-9.939 c-0.433,0-0.785-0.351-0.785-0.785v-0.283c0-0.433,0.351-0.785,0.785-0.785h9.939c0.433,0,0.785,0.351,0.785,0.785v0.283 C183.721,65.082,183.37,65.433,182.937,65.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M168.777,64.004h-0.658c-1.01,0-1.829-0.819-1.829-1.829 v-0.658c0-1.01,0.819-1.829,1.829-1.829h0.658c1.01,0,1.829,0.819,1.829,1.829v0.658 C170.605,63.185,169.787,64.004,168.777,64.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M223.697,61.804h-9.716 c-0.495,0-0.896-0.401-0.896-0.896v-0.323c0-0.495,0.401-0.896,0.896-0.896h9.716c0.495,0,0.896,0.401,0.896,0.896v0.323 C224.593,61.402,224.192,61.804,223.697,61.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M223.808,65.433h-9.939 c-0.433,0-0.785-0.351-0.785-0.785v-0.283c0-0.433,0.351-0.785,0.785-0.785h9.939c0.433,0,0.785,0.351,0.785,0.785v0.283 C224.593,65.082,224.242,65.433,223.808,65.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M209.648,64.004h-0.658c-1.01,0-1.829-0.819-1.829-1.829 v-0.658c0-1.01,0.819-1.829,1.829-1.829h0.658c1.01,0,1.829,0.819,1.829,1.829v0.658 C211.477,63.185,210.658,64.004,209.648,64.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M203.261,66.119h-9.716 c-0.495,0-0.896-0.401-0.896-0.896V64.9c0-0.495,0.401-0.896,0.896-0.896h9.716c0.495,0,0.896,0.401,0.896,0.896v0.323 C204.157,65.718,203.756,66.119,203.261,66.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M203.372,69.749h-9.939 c-0.433,0-0.785-0.351-0.785-0.785v-0.283c0-0.433,0.351-0.785,0.785-0.785h9.939c0.433,0,0.785,0.351,0.785,0.785v0.283 C204.157,69.397,203.806,69.749,203.372,69.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M189.213,68.319h-0.658c-1.01,0-1.829-0.819-1.829-1.829 v-0.658c0-1.01,0.819-1.829,1.829-1.829h0.658c1.01,0,1.829,0.819,1.829,1.829v0.658 C191.041,67.501,190.222,68.319,189.213,68.319z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.14,136.442h26.371c0,0,0.885-1.941-0.138-4.325c-0.353-0.575-3.4-3.861-2.85-7.794 c0.55-2.695,2.641-8.359,9.257-8.359c6.616,0,9.372,5.844,9.372,8.749s-0.649,4.872-2.856,7.437 c-0.312,0.809-0.874,2.247-0.132,4.293c2.148,0,22.462,0,22.462,0s2.279-0.4,2.279,2.255c0,2.655,0,23.099,0,23.099 s1.766,0.766,4.043-0.655c1.177-0.938,4.193-3.316,8.498-2.226c2.194,0.7,7.054,2.643,7.054,9.63c0,0-0.378,6.726-7.133,8.489 c-3.221,0.535-5.483,0.233-8.694-2.431c-1.171-0.502-1.928-0.976-3.768-0.548c0,3.214,0,25.953,0,25.953h-25.075 c0,0-0.187-2.161,0.894-3.598c1.09-1.452,3.948-4.944,1.436-10.416c-1.514-2.677-3.418-4.557-7.837-5.075 c-2.422,0-9.066,0.879-9.797,9.065c0,3.315,1.125,4.782,2.872,7.123c0.247,0.605,0.704,1.182,0.447,2.899 c-2.214,0-26.755,0-26.755,0v-26.003c0,0,1.701-0.409,3.259,0.329c0.714,0.439,2.976,2.802,6.549,2.918 c2.249-0.136,6.793-0.444,9.136-5.884c0.57-2.351,2.126-8.233-4.953-12.007c-2.846-0.76-5.788-1.418-9.458,1.297 c-1.22,0.905-2.143,1.553-4.484,1.245C200.14,158.621,200.14,136.442,200.14,136.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.379,238.477c0,0,0,20.17,0,22.826c0,2.655,2.279,2.255,2.279,2.255s20.314,0,22.462,0 c0.741,2.046,0.18,3.484-0.133,4.293c-2.206,2.565-2.856,4.532-2.856,7.437c0,2.905,2.756,8.749,9.372,8.749 c6.616,0,8.707-5.664,9.257-8.359c0.55-3.933-2.497-7.219-2.85-7.794c-1.023-2.384-0.138-4.325-0.138-4.325h26.371 c0,0,0-22.18,0-25.462c-2.34-0.307-3.264,0.34-4.484,1.245c-3.67,2.715-6.612,2.057-9.458,1.297 c-7.079-3.774-5.523-9.656-4.953-12.007c2.343-5.44,6.887-5.748,9.136-5.884c3.573,0.116,5.835,2.479,6.549,2.918 c1.558,0.738,3.259,0.329,3.259,0.329v-26.003c0,0-24.541,0-26.755,0c-0.257,1.717,0.201,2.294,0.447,2.899 c1.748,2.341,2.872,3.808,2.872,7.123c-0.731,8.186-7.375,9.065-9.797,9.065c-4.418-0.517-6.323-2.398-7.837-5.075 c-2.512-5.472,0.347-8.964,1.436-10.416c1.081-1.437,0.894-3.598,0.894-3.598h-25.075c0,0,0,22.739,0,25.953 c0,0-2.336,0.936-4.38-0.295c-0.764-0.557-2.246-2.053-4.316-2.458c-1.516-0.36-6.033-1.068-9.51,2.917 c-1.979,2.877-2.707,5.232-1.894,8.577c0.634,2.266,2.396,6.009,8.148,6.758c2.069-0.058,2.892,0.345,6.89-2.141 c0.681-0.616,2.048-1.51,4.221-1.055L136.379,238.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.375,174.274l0.173,25.734h25.038c0,0,0.348,1.493-0.654,2.965 c-1.001,1.472-3.255,3.613-2.69,7.596c1.314,4.462,3.021,7.533,8.92,8.244c3.061-0.359,8.306-1.476,9.709-7.136 c0-3.025-0.113-5.921-1.87-7.678c-1.293-1.293-2.005-2.963-1.463-3.991c2.369,0.14,26.282,0,26.282,0l0.319-25.974 c0,0,2.32-0.486,3.848,0.68c1.364,1.063,2.102,1.756,4.126,2.275c1.351,0.237,5.405,1.341,9.594-3.283 c1.517-2.878,3.517-6.744,0-11.463s-9.008-3.547-9.962-3.203c-0.994,0.36-2.57,1.028-3.478,1.936 c-0.709,0.709-2.386,1.354-4.127,0.927c0-2.583,0-25.462,0-25.462h-26.256c0,0-1.161-2.644,0.646-5.066 c1.307-1.894,3.076-4.245,2.022-8.564c-0.974-2.303-1.74-4.916-6.508-6.514c-2.013-0.313-7.259-1.357-10.795,4.721 c-2.058,4.441-0.722,7.583,1.585,10.664c0.57,1.233,1.242,2.084,0.397,4.759c-3.84,0-22.337,0-22.337,0s-2.519-0.619-2.519,2.705 c0,3.324,0,22.517,0,22.517s-2.332,0.944-4.683-0.4c-1.104-0.89-3.451-3.014-7.972-2.488c-1.509,0.378-6.455,1.633-7.679,7.922 c-0.775,4.582,2.699,9.18,6.607,10.22c3.758,1.01,6.885-0.451,8.706-1.981C131.944,174.514,132.988,173.496,136.375,174.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.625,225.702l-0.173-25.734l-25.038,0c0,0-0.347-1.493,0.654-2.965 c1.001-1.472,3.255-3.613,2.69-7.596c-1.314-4.462-3.021-7.533-8.92-8.244c-3.061,0.359-8.306,1.476-9.709,7.136 c0,3.025,0.113,5.921,1.87,7.678c1.293,1.293,2.005,2.963,1.463,3.991c-2.369-0.14-26.282,0-26.282,0l-0.319,25.974 c0,0-2.32,0.486-3.848-0.68c-1.364-1.063-2.102-1.756-4.126-2.275c-1.351-0.237-5.405-1.341-9.594,3.282 c-1.517,2.878-3.517,6.743,0,11.463c3.517,4.72,9.008,3.547,9.962,3.203c0.994-0.36,2.57-1.028,3.478-1.936 c0.709-0.709,2.386-1.354,4.127-0.927c0,2.583,0,25.462,0,25.462l26.256,0c0,0,1.161,2.644-0.646,5.066 c-1.307,1.894-3.076,4.245-2.022,8.564c0.974,2.303,1.74,4.916,6.508,6.514c2.013,0.314,7.259,1.357,10.795-4.721 c2.058-4.441,0.722-7.583-1.585-10.664c-0.57-1.233-1.242-2.084-0.397-4.759c3.84,0,22.337,0,22.337,0s2.519,0.62,2.519-2.705 c0-3.324,0-22.517,0-22.517s2.332-0.944,4.683,0.4c1.104,0.89,3.451,3.014,7.972,2.488c1.509-0.378,6.455-1.633,7.679-7.922 c0.775-4.582-2.699-9.18-6.607-10.22c-3.758-1.01-6.885,0.451-8.706,1.981C268.056,225.462,267.012,226.48,263.625,225.702z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M263.905,238.425 v23.268c0,1.034-0.836,1.881-1.881,1.881h-23.696"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M136.375,238.477 v23.216c0,1.034,0.836,1.881,1.87,1.881h23.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M136.375,161.663 v-23.351c0-1.034,0.836-1.87,1.87-1.87h22.986"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M239.164,136.442 h22.86c1.045,0,1.881,0.836,1.881,1.87v23.571"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 263.905,226.253 263.905,200.008 263.905,174.055  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 173.884,136.442 200.14,136.442 226.511,136.442  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 136.375,225.867 136.375,200.008 136.375,174.274  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 173.821,263.574 200.14,263.574 225.821,263.574  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 200.14,
    y1: 263.574,
    x2: 200.14,
    y2: 238.446
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 200.14,
    y1: 161.903,
    x2: 200.14,
    y2: 136.442
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 200.14,174.034 200.14,200.008 200.14,226.358  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 263.905,
    y1: 200.008,
    x2: 238.829,
    y2: 200.008
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 161.587,
    y1: 200.008,
    x2: 136.375,
    y2: 200.008
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 173.539,200.008 200.14,200.008 226.845,200.008  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.231,136.442 c0.522-1.41,0.606-3.406-0.491-4.9c0,0,0-0.021-0.021-0.021c-0.209-0.219-0.418-0.46-0.596-0.721 c-1.191-1.557-1.881-3.49-1.881-5.579c0-5.12,4.148-9.257,9.257-9.257c0.334,0,0.648,0.031,0.982,0.052 c4.712,0.439,8.39,4.399,8.39,9.215c0,2.09-0.7,4.023-1.87,5.579c-0.199,0.261-0.407,0.491-0.616,0.731 c-1.097,1.494-1.034,3.5-0.502,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.587,200.008 c0.084,1.097-0.125,2.278-0.846,3.249c-0.209,0.24-0.418,0.47-0.616,0.731c-1.17,1.546-1.881,3.479-1.881,5.579 c0,4.817,3.688,8.766,8.39,9.215c0.334,0.021,0.658,0.042,0.993,0.042c5.109,0,9.247-4.137,9.247-9.247 c0-2.1-0.69-4.033-1.87-5.579c-0.188-0.261-0.397-0.512-0.606-0.731c-0.01,0-0.01-0.01-0.01-0.01 c-0.71-0.972-0.93-2.152-0.846-3.249"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.315,263.574 c0.46,1.39,0.481,3.281-0.575,4.712c-0.209,0.23-0.418,0.46-0.616,0.721c-1.17,1.557-1.881,3.49-1.881,5.579 c0,4.817,3.688,8.776,8.39,9.215c0.334,0.031,0.658,0.052,0.993,0.052c5.109,0,9.247-4.137,9.247-9.257 c0-2.09-0.69-4.023-1.87-5.579c-0.188-0.251-0.397-0.501-0.606-0.721c-0.01,0-0.01-0.01-0.01-0.01 c-1.045-1.421-1.024-3.312-0.564-4.712"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M225.821,263.574 c0.46,1.39,0.47,3.281-0.585,4.712c-0.209,0.23-0.418,0.46-0.616,0.721c-1.17,1.557-1.87,3.49-1.87,5.579 c0,4.817,3.688,8.776,8.39,9.215c0.334,0.031,0.658,0.052,0.993,0.052c5.109,0,9.247-4.137,9.247-9.257 c0-2.09-0.69-4.023-1.87-5.579c-0.188-0.251-0.397-0.501-0.606-0.721c-0.01,0-0.01-0.01-0.01-0.01 c-1.045-1.431-1.024-3.323-0.564-4.712"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M136.375,174.274 c-1.41-0.502-3.385-0.564-4.858,0.512c0,0-0.01,0-0.01,0.01c-0.219,0.209-0.47,0.418-0.731,0.606 c-1.546,1.181-3.479,1.87-5.579,1.87c-5.109,0-9.247-4.137-9.247-9.247c0-0.334,0.021-0.658,0.052-0.982 c0.439-4.712,4.399-8.39,9.215-8.39c2.09,0,4.023,0.7,5.579,1.87c0.251,0.199,0.491,0.407,0.721,0.616 c1.473,1.087,3.458,1.024,4.858,0.522"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M136.375,238.477 c-1.41-0.502-3.385-0.564-4.858,0.512c0,0-0.01,0-0.01,0.01c-0.219,0.209-0.47,0.418-0.731,0.606 c-1.546,1.181-3.479,1.87-5.579,1.87c-5.109,0-9.247-4.137-9.247-9.247c0-0.334,0.021-0.658,0.052-0.982 c0.439-4.712,4.399-8.39,9.215-8.39c2.09,0,4.023,0.7,5.579,1.87c0.251,0.199,0.491,0.407,0.721,0.616 c1.473,1.087,3.458,1.024,4.858,0.522"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M200.14,161.903 c1.264,0.251,2.758,0.104,3.939-0.763c0.24-0.209,0.47-0.418,0.731-0.616c1.557-1.17,3.49-1.87,5.579-1.87 c4.817,0,8.776,3.678,9.215,8.39c0.021,0.324,0.052,0.648,0.052,0.982c0,5.109-4.137,9.247-9.257,9.247 c-2.09,0-4.023-0.69-5.579-1.87c-0.261-0.188-0.502-0.397-0.721-0.606c0-0.01-0.01-0.01-0.01-0.01 c-1.181-0.867-2.685-0.993-3.949-0.752"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M200.14,226.358 c-1.254,0.219-2.717,0.073-3.866-0.773c0,0-0.01,0-0.01-0.01c-0.219-0.209-0.47-0.428-0.721-0.606 c-1.557-1.181-3.49-1.87-5.59-1.87c-5.109,0-9.247,4.137-9.247,9.247c0,0.334,0.021,0.648,0.052,0.982 c0.439,4.712,4.399,8.39,9.215,8.39c2.09,0,4.023-0.7,5.579-1.87c0.261-0.199,0.491-0.407,0.721-0.616 c1.149-0.846,2.612-1.003,3.866-0.784"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M263.905,161.883 c1.285,0.272,2.831,0.146,4.043-0.742c0.23-0.209,0.47-0.418,0.721-0.616c1.557-1.17,3.49-1.87,5.59-1.87 c4.817,0,8.766,3.678,9.215,8.39c0.021,0.324,0.042,0.648,0.042,0.982c0,5.109-4.137,9.247-9.247,9.247 c-2.1,0-4.033-0.69-5.579-1.87c-0.261-0.188-0.512-0.397-0.731-0.606c0-0.01-0.01-0.01-0.01-0.01 c-1.212-0.888-2.758-1.003-4.043-0.731"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M263.905,226.253 c1.285,0.272,2.831,0.146,4.043-0.742c0.23-0.209,0.47-0.418,0.721-0.616c1.557-1.17,3.49-1.87,5.59-1.87 c4.817,0,8.766,3.678,9.215,8.39c0.021,0.334,0.042,0.648,0.042,0.982c0,5.109-4.137,9.257-9.247,9.257 c-2.1,0-4.033-0.7-5.579-1.881c-0.261-0.178-0.512-0.387-0.731-0.596c0-0.021-0.01-0.021-0.01-0.021 c-1.212-0.888-2.758-1.003-4.043-0.731"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M226.511,136.442 c0.522-1.41,0.606-3.406-0.491-4.9c0,0,0-0.021-0.021-0.021c-0.209-0.219-0.418-0.46-0.596-0.721 c-1.191-1.557-1.881-3.49-1.881-5.579c0-5.12,4.148-9.257,9.257-9.257c0.334,0,0.648,0.031,0.982,0.052 c4.712,0.439,8.39,4.399,8.39,9.215c0,2.09-0.7,4.023-1.87,5.579c-0.199,0.261-0.407,0.491-0.616,0.731 c-1.097,1.494-1.034,3.5-0.501,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M226.845,200.008 c0.136-1.17-0.052-2.476-0.825-3.531c0,0,0-0.021-0.021-0.021c-0.209-0.219-0.418-0.46-0.596-0.721 c-1.191-1.557-1.881-3.49-1.881-5.579c0-5.12,4.148-9.257,9.257-9.257c0.334,0,0.648,0.031,0.982,0.052 c4.712,0.439,8.39,4.399,8.39,9.215c0,2.09-0.7,4.023-1.87,5.579c-0.199,0.261-0.407,0.491-0.616,0.731 c-0.773,1.055-0.972,2.361-0.836,3.531"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "M224.213,203.852l-2.883-1.224 c-0.48-0.204-0.778-0.69-0.74-1.21c0.138-1.919,0-3.821-0.387-5.658c-0.109-0.515,0.125-1.042,0.58-1.307l2.665-1.552 c0.552-0.321,0.764-1.014,0.486-1.59l-0.771-1.597l-0.754-1.561l-0.771-1.597c-0.278-0.576-0.952-0.84-1.547-0.607 l-2.919,1.141c-0.485,0.19-1.038,0.052-1.374-0.346c-1.307-1.546-2.851-2.909-4.604-4.025 c-0.443-0.282-0.653-0.817-0.524-1.326l0.755-2.983c0.157-0.62-0.19-1.255-0.796-1.46l-1.681-0.566l-1.643-0.553l-1.681-0.566 c-0.606-0.204-1.266,0.093-1.517,0.68l-1.226,2.882c-0.204,0.479-0.69,0.777-1.21,0.739c-1.944-0.142-3.871,0-5.73,0.398 c-0.515,0.11-1.043-0.122-1.309-0.577l-1.556-2.661c-0.323-0.552-1.015-0.762-1.59-0.483l-1.596,0.774l-1.559,0.757 l-1.595,0.774c-0.575,0.279-0.838,0.954-0.605,1.549l1.151,2.926c0.19,0.485,0.054,1.037-0.343,1.374 c-1.537,1.306-2.892,2.849-4.001,4.598c-0.281,0.443-0.816,0.654-1.325,0.526l-2.986-0.749 c-0.62-0.155-1.255,0.192-1.458,0.798l-0.563,1.682l-0.55,1.644l-0.563,1.682c-0.203,0.606,0.095,1.266,0.683,1.515 l2.885,1.221c0.479,0.203,0.779,0.687,0.742,1.206c-0.146,2.047,0.019,4.076,0.469,6.026c0.118,0.512-0.106,1.041-0.555,1.315 l-2.63,1.6c-0.546,0.332-0.745,1.029-0.456,1.599l0.802,1.582l0.784,1.546l0.802,1.582c0.289,0.57,0.968,0.822,1.559,0.577 l2.899-1.198c0.482-0.199,1.036-0.072,1.38,0.32c1.338,1.522,2.913,2.856,4.694,3.94c0.448,0.273,0.669,0.804,0.55,1.315 l-0.696,3.003c-0.144,0.623,0.215,1.252,0.825,1.443l1.692,0.533l1.653,0.521l1.692,0.532c0.61,0.192,1.264-0.118,1.503-0.711 l1.169-2.909c0.195-0.484,0.675-0.791,1.197-0.763c1.884,0.1,3.75-0.063,5.549-0.469c0.514-0.116,1.044,0.11,1.315,0.561 l1.588,2.639c0.329,0.548,1.025,0.75,1.596,0.463l1.586-0.794l1.55-0.776l1.586-0.794c0.571-0.286,0.826-0.964,0.585-1.556 l-1.184-2.904c-0.197-0.483-0.065-1.038,0.328-1.381c1.457-1.267,2.746-2.749,3.81-4.421c0.282-0.443,0.817-0.655,1.327-0.526 l2.984,0.753c0.62,0.156,1.255-0.191,1.459-0.797l0.565-1.681l0.552-1.643l0.565-1.681 C225.099,204.763,224.802,204.102,224.213,203.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.213,203.852l-2.883-1.224c-0.48-0.204-0.778-0.69-0.74-1.21 c0.138-1.919,0-3.821-0.387-5.658c-0.109-0.515,0.125-1.042,0.58-1.307l2.665-1.552c0.552-0.321,0.764-1.014,0.486-1.59 l-0.771-1.597l-0.754-1.561l-0.771-1.597c-0.278-0.576-0.952-0.84-1.547-0.607l-2.919,1.141 c-0.485,0.19-1.038,0.052-1.374-0.346c-1.307-1.546-2.851-2.909-4.604-4.025c-0.443-0.282-0.653-0.817-0.524-1.326l0.755-2.983 c0.157-0.62-0.19-1.255-0.796-1.46l-1.681-0.566l-1.643-0.553l-1.681-0.566c-0.606-0.204-1.266,0.093-1.517,0.68l-1.226,2.882 c-0.204,0.479-0.69,0.777-1.21,0.739c-1.944-0.142-3.871,0-5.73,0.398c-0.515,0.11-1.043-0.122-1.309-0.577l-1.556-2.661 c-0.323-0.552-1.015-0.762-1.59-0.483l-1.596,0.774l-1.559,0.757l-1.595,0.774c-0.575,0.279-0.838,0.954-0.605,1.549 l1.151,2.926c0.19,0.485,0.054,1.037-0.343,1.374c-1.537,1.306-2.892,2.849-4.001,4.598c-0.281,0.443-0.816,0.654-1.325,0.526 l-2.986-0.749c-0.62-0.155-1.255,0.192-1.458,0.798l-0.563,1.682l-0.55,1.644l-0.563,1.682 c-0.203,0.606,0.095,1.266,0.683,1.515l2.885,1.221c0.479,0.203,0.779,0.687,0.742,1.206c-0.146,2.047,0.019,4.076,0.469,6.026 c0.118,0.512-0.106,1.041-0.555,1.315l-2.63,1.6c-0.546,0.332-0.745,1.029-0.456,1.599l0.802,1.582l0.784,1.546l0.802,1.582 c0.289,0.57,0.968,0.822,1.559,0.577l2.899-1.198c0.482-0.199,1.036-0.072,1.38,0.32c1.338,1.522,2.913,2.856,4.694,3.94 c0.448,0.273,0.669,0.804,0.55,1.315l-0.696,3.003c-0.144,0.623,0.215,1.252,0.825,1.443l1.692,0.533l1.653,0.521l1.692,0.532 c0.61,0.192,1.264-0.118,1.503-0.711l1.169-2.909c0.195-0.484,0.675-0.791,1.197-0.763c1.884,0.1,3.75-0.063,5.549-0.469 c0.514-0.116,1.044,0.11,1.315,0.561l1.588,2.639c0.329,0.548,1.025,0.75,1.596,0.463l1.586-0.794l1.55-0.776l1.586-0.794 c0.571-0.286,0.826-0.964,0.585-1.556l-1.184-2.904c-0.197-0.483-0.065-1.038,0.328-1.381c1.457-1.267,2.746-2.749,3.81-4.421 c0.282-0.443,0.817-0.655,1.327-0.526l2.984,0.753c0.62,0.156,1.255-0.191,1.459-0.797l0.565-1.681l0.552-1.643l0.565-1.681 C225.099,204.763,224.802,204.102,224.213,203.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeMiterlimit: 10
    },
    d: "M224.213,203.852l-2.883-1.224 c-0.48-0.204-0.778-0.69-0.74-1.21c0.138-1.919,0-3.821-0.387-5.658c-0.109-0.515,0.125-1.042,0.58-1.307l2.665-1.552 c0.552-0.321,0.764-1.014,0.486-1.59l-0.771-1.597l-0.754-1.561l-0.771-1.597c-0.278-0.576-0.952-0.84-1.547-0.607 l-2.919,1.141c-0.485,0.19-1.038,0.052-1.374-0.346c-1.307-1.546-2.851-2.909-4.604-4.025 c-0.443-0.282-0.653-0.817-0.524-1.326l0.755-2.983c0.157-0.62-0.19-1.255-0.796-1.46l-1.681-0.566l-1.643-0.553l-1.681-0.566 c-0.606-0.204-1.266,0.093-1.517,0.68l-1.226,2.882c-0.204,0.479-0.69,0.777-1.21,0.739c-1.944-0.142-3.871,0-5.73,0.398 c-0.515,0.11-1.043-0.122-1.309-0.577l-1.556-2.661c-0.323-0.552-1.015-0.762-1.59-0.483l-1.596,0.774l-1.559,0.757 l-1.595,0.774c-0.575,0.279-0.838,0.954-0.605,1.549l1.151,2.926c0.19,0.485,0.054,1.037-0.343,1.374 c-1.537,1.306-2.892,2.849-4.001,4.598c-0.281,0.443-0.816,0.654-1.325,0.526l-2.986-0.749 c-0.62-0.155-1.255,0.192-1.458,0.798l-0.563,1.682l-0.55,1.644l-0.563,1.682c-0.203,0.606,0.095,1.266,0.683,1.515 l2.885,1.221c0.479,0.203,0.779,0.687,0.742,1.206c-0.146,2.047,0.019,4.076,0.469,6.026c0.118,0.512-0.106,1.041-0.555,1.315 l-2.63,1.6c-0.546,0.332-0.745,1.029-0.456,1.599l0.802,1.582l0.784,1.546l0.802,1.582c0.289,0.57,0.968,0.822,1.559,0.577 l2.899-1.198c0.482-0.199,1.036-0.072,1.38,0.32c1.338,1.522,2.913,2.856,4.694,3.94c0.448,0.273,0.669,0.804,0.55,1.315 l-0.696,3.003c-0.144,0.623,0.215,1.252,0.825,1.443l1.692,0.533l1.653,0.521l1.692,0.532c0.61,0.192,1.264-0.118,1.503-0.711 l1.169-2.909c0.195-0.484,0.675-0.791,1.197-0.763c1.884,0.1,3.75-0.063,5.549-0.469c0.514-0.116,1.044,0.11,1.315,0.561 l1.588,2.639c0.329,0.548,1.025,0.75,1.596,0.463l1.586-0.794l1.55-0.776l1.586-0.794c0.571-0.286,0.826-0.964,0.585-1.556 l-1.184-2.904c-0.197-0.483-0.065-1.038,0.328-1.381c1.457-1.267,2.746-2.749,3.81-4.421c0.282-0.443,0.817-0.655,1.327-0.526 l2.984,0.753c0.62,0.156,1.255-0.191,1.459-0.797l0.565-1.681l0.552-1.643l0.565-1.681 C225.099,204.763,224.802,204.102,224.213,203.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1036 -0.9946 0.9946 0.1036 -19.475 378.4068)",
    style: {
      fill: "#FFFFFF",
      stroke: "#2F86DD",
      strokeMiterlimit: 10
    },
    cx: 200.193,
    cy: 200.008,
    rx: 13.455,
    ry: 13.455
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M207.784,197.691h-5.313v-5.313c0-1.255-1.018-2.273-2.273-2.273s-2.273,1.018-2.273,2.273v5.313 h-5.314c-1.255,0-2.273,1.018-2.273,2.273s1.018,2.273,2.273,2.273h5.314v5.314c0,1.255,1.018,2.273,2.273,2.273 s2.273-1.018,2.273-2.273v-5.314h5.313c1.255,0,2.273-1.018,2.273-2.273S209.04,197.691,207.784,197.691z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M177.196,150.657l0,31.362H157.94v-31.362H177.196 M178.196,149.657H156.94v33.362h21.256 L178.196,149.657L178.196,149.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M165.766,160.927v3.202h-5.209v-3.202H165.766 M166.766,159.927h-7.209v5.202h7.209V159.927 L166.766,159.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M174.58,160.927v3.202h-5.209v-3.202H174.58 M175.58,159.927h-7.209v5.202h7.209V159.927 L175.58,159.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M165.766,175.848v3.202h-5.209v-3.202H165.766 M166.766,174.848h-7.209v5.202h7.209V174.848 L166.766,174.848z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M165.766,168.319v3.202h-5.209v-3.202H165.766 M166.766,167.319h-7.209v5.202h7.209V167.319 L166.766,167.319z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M174.58,175.848v3.202h-5.209v-3.202H174.58 M175.58,174.848h-7.209v5.202h7.209V174.848 L175.58,174.848z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M174.58,168.319v3.202h-5.209v-3.202H174.58 M175.58,167.319h-7.209v5.202h7.209V167.319 L175.58,167.319z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    x1: 153.244,
    y1: 175.792,
    x2: 153.244,
    y2: 182.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M181.892,172.152c1.487,0,2.696,1.209,2.696,2.696s-1.209,2.696-2.696,2.696 s-2.696-1.209-2.696-2.696S180.406,172.152,181.892,172.152 M181.892,171.152c-2.041,0-3.696,1.655-3.696,3.696 s1.655,3.696,3.696,3.696c2.041,0,3.696-1.655,3.696-3.696S183.933,171.152,181.892,171.152L181.892,171.152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M153.612,169.824c1.487,0,2.696,1.209,2.696,2.696s-1.209,2.696-2.696,2.696 s-2.696-1.209-2.696-2.696S152.125,169.824,153.612,169.824 M153.612,168.824c-2.041,0-3.696,1.655-3.696,3.696 s1.655,3.696,3.696,3.696s3.696-1.655,3.696-3.696S155.653,168.824,153.612,168.824L153.612,168.824z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    x1: 181.892,
    y1: 178.544,
    x2: 181.892,
    y2: 182.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    x1: 149.548,
    y1: 182.499,
    x2: 185.588,
    y2: 182.499
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M165.766,153.398v3.202h-5.209v-3.202H165.766 M166.766,152.398h-7.209v5.202h7.209V152.398 L166.766,152.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M174.58,153.398v3.202h-5.209v-3.202H174.58 M175.58,152.398h-7.209v5.202h7.209V152.398 L175.58,152.398z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065784421440752145370000003040296240059172528_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060749437037344985160000015475333401666688439_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M241.614,225.723c1.238,0,2.106,0.277,2.653,0.846c0.649,0.675,0.938,1.825,0.938,3.73 c0,1.166-0.361,2.286-1.016,3.153c-0.693,0.918-1.607,1.423-2.575,1.423c-1.097,0-2.138-0.673-2.817-1.79 c1.02-1.468,1.579-3.284,1.579-5.153c0-0.744-0.035-1.4-0.107-2.004c-0.004-0.033,0.031-0.069,0.078-0.08 C240.716,225.766,241.142,225.723,241.614,225.723 M241.614,224.723c-0.561,0-1.054,0.052-1.488,0.151 c-0.541,0.122-0.915,0.622-0.85,1.173c0.077,0.649,0.1,1.292,0.1,1.886c0,1.765-0.556,3.474-1.565,4.811 c-0.063,0.083-0.133,0.156-0.198,0.236c0.782,1.719,2.271,2.896,4.002,2.896c1.34,0,2.534-0.709,3.374-1.821 c0.749-0.992,1.218-2.303,1.218-3.756c0-1.805-0.238-3.404-1.218-4.423C244.295,225.156,243.235,224.723,241.614,224.723 L241.614,224.723z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000129887271576194276430000017145760982897065891_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M244.432,237.38c0.117,0.024,0.232,0.048,0.345,0.072c3.789,0.813,4.419,1.757,4.498,6.727 c0.001,0.09,0.003,0.217,0.019,0.357h-0.01l0,0.084c-0.344,0.364-1.483,1.288-4.436,1.699 c-0.251,0.035-0.508,0.066-0.772,0.092c0.463-0.46,0.67-0.827,0.736-0.959c0.133-0.263,0.203-0.558,0.203-0.853v-0.474 c0-0.052-0.002-0.103-0.007-0.154l-0.002-0.139l-0.002-0.16c-0.039-2.461-0.195-4.421-0.827-5.99 c-0.025-0.061-0.015-0.111-0.016-0.114C244.263,237.505,244.353,237.441,244.432,237.38 M244.128,236.304 c0,0-0.16,0.203-0.504,0.422c-0.44,0.281-0.569,0.847-0.374,1.331c0.576,1.43,0.717,3.265,0.755,5.632 c0,0.001,0,0.002,0,0.004c0.002,0.172,0.003,0.276,0.005,0.334c0.004,0.033,0.006,0.065,0.006,0.099v0.474 c0,0.14-0.033,0.277-0.096,0.402c-0.095,0.19-0.872,1.543-3.714,2.488c0.445,0.022,0.908,0.037,1.408,0.037 c1.311,0,2.42-0.084,3.373-0.217c4.424-0.617,5.297-2.357,5.297-2.357c0-0.192,0-0.326,0-0.417c0,0.005,0,0.007-0.001,0.007 c-0.002,0-0.005-0.086-0.009-0.379c-0.081-5.062-0.713-6.708-5.288-7.69C244.713,236.416,244.43,236.359,244.128,236.304 L244.128,236.304z M250.285,244.537h0.005H250.285z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000053515939428820946890000004132963336285486229_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M219.694,237.38h0.005H219.694 M219.684,237.382c0.008,0.002,0.025,0.008,0.043,0.021 c0.048,0.036,0.099,0.073,0.157,0.112c0.064,0.043,0.096,0.125,0.079,0.166c-0.541,1.358-0.783,3.035-0.835,5.787 c-0.003,0.144-0.005,0.242-0.007,0.308c-0.006,0.06-0.009,0.122-0.009,0.183v0.641c0,0.292,0.069,0.585,0.197,0.841 c0.089,0.18,0.301,0.54,0.73,0.972c-3.565-0.351-4.852-1.418-5.196-1.781l0-0.245h-0.007c0.016-0.144,0.019-0.277,0.02-0.378 C214.944,239.33,215.37,238.242,219.684,237.382 M219.682,236.382c-0.061,0-0.122,0.006-0.183,0.018 c-4.849,0.964-5.547,2.538-5.642,7.592c-0.006,0.33-0.01,0.418-0.012,0.418c-0.001,0-0.001-0.007-0.001-0.019 c0,0.092,0.001,0.264,0.001,0.563c0,0,1.277,2.573,8.669,2.573c0,0,0.001,0,0.001,0c0.492,0,0.948-0.015,1.386-0.037 c-2.808-0.935-3.584-2.268-3.695-2.492c-0.062-0.124-0.093-0.26-0.093-0.397v-0.641c0-0.039,0.002-0.077,0.007-0.114 c0.002-0.066,0.005-0.178,0.008-0.358c0.044-2.329,0.225-4.084,0.764-5.436c0.197-0.495-0.007-1.067-0.449-1.365 c-0.041-0.028-0.078-0.054-0.113-0.081C220.142,236.465,219.914,236.382,219.682,236.382L219.682,236.382z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083806106300103865020000007987448092413338274_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M232.066,222.59c1.446,0,2.465,0.329,3.115,1.004c0.765,0.795,1.106,2.133,1.106,4.338 c0,1.356-0.42,2.659-1.183,3.669c-0.815,1.079-1.894,1.673-3.039,1.673c-2.328,0-4.221-2.396-4.221-5.342 c0-3.945,1.105-5.343,4.221-5.343H232.066 M232.066,221.59c0,0-0.001,0-0.001,0c-4.454,0-5.221,2.84-5.221,6.343 c0,3.503,2.338,6.342,5.221,6.342c0,0,0,0,0,0c1.524,0,2.882-0.806,3.837-2.071c0.852-1.129,1.385-2.62,1.385-4.272 c0-2.053-0.27-3.872-1.385-5.031C235.114,222.083,233.909,221.59,232.066,221.59L232.066,221.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114072550432421928060000011418345736535508154_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M235.237,235.84c0.155,0.031,0.306,0.062,0.454,0.094c4.647,0.998,5.139,2.366,5.225,7.784 c0.002,0.108,0.004,0.253,0.022,0.408h-0.012l0,0.149c-0.37,0.41-1.669,1.528-5.164,2.016c-1.127,0.157-2.371,0.237-3.7,0.237 c-6.402,0-8.418-1.748-8.861-2.242l0-0.329h-0.007c0.017-0.157,0.02-0.308,0.022-0.432c0.1-5.34,0.632-6.689,5.682-7.68 c0.477,0.378,1.523,1.012,3.166,1.012C233.664,236.856,234.691,236.276,235.237,235.84 M234.924,234.762 c0,0-0.859,1.094-2.859,1.094c-1.314,0-2.136-0.472-2.545-0.796c-0.182-0.144-0.41-0.217-0.641-0.217 c-0.071,0-0.143,0.007-0.213,0.021c-5.543,1.096-6.341,2.882-6.449,8.642c-0.007,0.376-0.011,0.476-0.014,0.476 c-0.001,0-0.001-0.009-0.002-0.021c0,0.105,0.001,0.301,0.001,0.641c0,0,1.453,2.927,9.861,2.927c0,0,0.001,0,0.001,0 c1.491,0,2.753-0.095,3.837-0.246c5.033-0.703,6.025-2.681,6.025-2.681c0-0.219,0-0.371,0-0.474 c0,0.005-0.001,0.008-0.001,0.008c-0.002,0-0.005-0.098-0.01-0.431c-0.092-5.758-0.811-7.63-6.015-8.747 C235.59,234.889,235.268,234.824,234.924,234.762L234.924,234.762z M241.927,244.126h0.005H241.927z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031926990027648303190000012374032790548655537_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M222.515,225.724c0.468,0,0.893,0.045,1.264,0.135c0.042,0.01,0.084,0.043,0.079,0.081 c-0.07,0.605-0.105,1.257-0.105,1.993c0,1.893,0.555,3.7,1.574,5.162c-0.078,0.133-0.157,0.252-0.237,0.358 c-0.693,0.918-1.608,1.423-2.576,1.423c-1.98,0-3.59-2.053-3.59-4.576C218.924,226.879,219.83,225.724,222.515,225.724  M222.515,224.724c-3.916,0-4.591,2.497-4.591,5.576c0,3.08,2.055,5.576,4.59,5.576c0,0,0,0,0,0 c1.34,0,2.534-0.709,3.374-1.821c0.241-0.32,0.44-0.682,0.617-1.062c-1.082-1.306-1.752-3.092-1.752-5.06 c0-0.618,0.025-1.253,0.098-1.878c0.064-0.546-0.303-1.04-0.838-1.169C223.58,224.782,223.085,224.724,222.515,224.724 L222.515,224.724z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000122698445744305674080000014617483631733613184_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M166.564,222.793c1.447,0,2.466,0.329,3.116,1.004c0.765,0.795,1.106,2.133,1.106,4.338 c0,1.356-0.42,2.659-1.183,3.669c-0.814,1.079-1.894,1.673-3.039,1.673c-2.328,0-4.221-2.396-4.221-5.342 C162.343,224.192,163.447,222.793,166.564,222.793 M166.564,221.793c-4.454,0-5.221,2.84-5.221,6.343s2.338,6.342,5.221,6.342 c1.524,0,2.882-0.806,3.837-2.071c0.852-1.129,1.385-2.62,1.385-4.272c0-2.053-0.27-3.872-1.385-5.031 C169.614,222.286,168.408,221.793,166.564,221.793L166.564,221.793z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000107550619070979268650000016548971319909164206_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M169.737,236.043c0.155,0.031,0.306,0.062,0.454,0.094c4.647,0.998,5.139,2.366,5.225,7.784 c0.002,0.108,0.004,0.253,0.022,0.408h-0.012l0,0.149c-0.37,0.41-1.669,1.528-5.164,2.016c-1.127,0.157-2.371,0.237-3.7,0.237 c-6.402,0-8.418-1.748-8.861-2.242l0-0.329h-0.007c0.017-0.157,0.02-0.308,0.022-0.432c0.1-5.34,0.632-6.689,5.682-7.68 c0.583,0.462,1.605,1.012,3.166,1.012C168.163,237.059,169.19,236.479,169.737,236.043 M169.424,234.965 c0,0-0.859,1.094-2.859,1.094c0,0-0.001,0-0.001,0c-1.314,0-2.135-0.472-2.544-0.796c-0.182-0.144-0.411-0.217-0.641-0.217 c-0.071,0-0.143,0.007-0.213,0.021c-5.543,1.096-6.341,2.882-6.449,8.642c-0.007,0.376-0.011,0.476-0.014,0.476 c-0.001,0-0.001-0.009-0.002-0.021c0,0.105,0.001,0.301,0.001,0.641c0,0,1.452,2.927,9.861,2.927c0,0,0.001,0,0.001,0 c1.491,0,2.753-0.095,3.837-0.246c5.033-0.703,6.025-2.681,6.025-2.681c0-0.219,0-0.371,0-0.474 c0,0.005-0.001,0.008-0.001,0.008c-0.002,0-0.005-0.098-0.01-0.431c-0.092-5.758-0.811-7.63-6.015-8.747 C170.09,235.092,169.768,235.027,169.424,234.965L169.424,234.965z M176.427,244.329h0.005H176.427z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080201910116205174820000010017402620085172664_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M232.839,151.279c1.446,0,2.465,0.329,3.115,1.004c0.765,0.795,1.106,2.133,1.106,4.338 c0,1.356-0.42,2.659-1.183,3.669c-0.815,1.079-1.894,1.673-3.039,1.673c-2.328,0-4.221-2.396-4.221-5.342 c0-3.945,1.105-5.343,4.221-5.343H232.839 M232.839,150.279c0,0-0.001,0-0.001,0c-4.454,0-5.221,2.84-5.221,6.343 c0,3.503,2.338,6.342,5.221,6.342c0,0,0,0,0,0c1.524,0,2.882-0.806,3.837-2.071c0.852-1.129,1.385-2.62,1.385-4.272 c0-2.053-0.27-3.872-1.385-5.031C235.887,150.772,234.682,150.279,232.839,150.279L232.839,150.279z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029762942548545082950000006072810382477456776_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD"
    },
    d: "M236.01,164.529c0.155,0.031,0.306,0.062,0.454,0.094c4.647,0.998,5.139,2.366,5.225,7.784 c0.002,0.108,0.004,0.253,0.022,0.408H241.7l0,0.149c-0.369,0.41-1.669,1.528-5.164,2.016c-1.126,0.157-2.37,0.237-3.7,0.237 c-6.402,0-8.418-1.748-8.861-2.242l0-0.328h-0.007c0.017-0.157,0.02-0.308,0.022-0.433c0.1-5.34,0.632-6.689,5.682-7.68 c0.477,0.378,1.523,1.012,3.166,1.012C234.437,165.545,235.464,164.965,236.01,164.529 M235.697,163.451 c0,0-0.859,1.094-2.859,1.094c-1.314,0-2.136-0.472-2.545-0.796c-0.182-0.144-0.41-0.217-0.641-0.217 c-0.071,0-0.143,0.007-0.213,0.021c-5.543,1.096-6.341,2.882-6.449,8.642c-0.007,0.376-0.011,0.476-0.013,0.476 c-0.001,0-0.001-0.009-0.002-0.021c0,0.105,0.001,0.301,0.001,0.641c0,0,1.452,2.927,9.861,2.927c0,0,0.001,0,0.001,0 c1.491,0,2.753-0.095,3.837-0.247c5.033-0.702,6.025-2.681,6.025-2.681c0-0.219,0-0.371,0-0.474 c0,0.005-0.001,0.008-0.001,0.008c-0.002,0-0.005-0.098-0.01-0.431c-0.092-5.758-0.811-7.63-6.015-8.747 C236.363,163.578,236.041,163.513,235.697,163.451L235.697,163.451z M242.7,172.815h0.005H242.7z"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInventory);
export default __webpack_public_path__ + "static/media/empty-inventory.a4dffe69bf29febc9de0ef3f0fbf740f.svg";
export { ForwardRef as ReactComponent };